import React from 'react';
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import Footer from '../Global/Footer';
import Header from '../Global/Header';

function Dashboard() {
  return (
    <>
      <Header />
      {/* <!-- content begin --> */}

      
    
       

        <section aria-label="section">
          <div className="container-fluid auth-bg" >
            <div className="row profile">
              <div className="col-md-12">
              <h2 className='heading'>$LITTLE Admin Panel</h2>
                <p className='para-sub'>Benefit from a handful of unique utilities and experience the power<br />
                        of a token that proves its value right from the start</p>
              </div>

              <div className="col-md-12">
                <div className="de_tab tab_simple">
                  
                  <Tabs>
                    <TabList>
                      <Tab>Settings</Tab>
                      <Tab>Withdraw Rewards</Tab>
                    </TabList>

                    <TabPanel>
                      <div className="container dashboard">
                    <h1 className='edit'>Edit your Profile at $LITTLE</h1>
                    
                    <div className="row dash">
                    {/* <!-- left column --> */}
                    <div className="col-md-4 avtar">
                        <div className="text-center">
                        <img src={"images/place.png"} className="avatar img-circle" alt="avatar" />
                        <h6>Upload a different photo...</h6>
                        
                        <input type="file" className="form-control" />
                        </div>
                    </div>
                    
                    {/* <!-- edit form column --> */}
                    <div className="col-md-8 personal-info">
                        {/* <div className="alert alert-info alert-dismissable">
                        <a className="panel-close close" data-dismiss="alert">X</a> 
                        <i className="fa fa-coffee"></i>
                        This is an <strong>.alert</strong>. Use this to show important messages to the user.
                        </div> */}
                        <h2>Personal info</h2>
                        
                        <form className="form-horizontal">
                        <div className="form-group">
                            <label className="col-lg-3 control-label">First name:</label>
                            <div className="col-lg-8">
                            <input className="form-control" type="text" />
                            </div>
                        </div>
                        <div className="form-group">
                            <label className="col-lg-3 control-label">Last name:</label>
                            <div className="col-lg-8">
                            <input className="form-control" type="text" />
                            </div>
                        </div>
                        {/* <div className="form-group">
                            <label className="col-lg-3 control-label">Company:</label>
                            <div className="col-lg-8">
                            <input className="form-control" type="text" />
                            </div>
                        </div> */}
                        <div className="form-group">
                            <label className="col-lg-3 control-label">Email:</label>
                            <div className="col-lg-8">
                            <input className="form-control" type="email" />
                            </div>
                        </div>
                        {/* <div className="form-group">
                            <label className="col-lg-3 control-label">Time Zone:</label>
                            <div className="col-lg-8">
                            <div className="ui-select">
                                <select id="user_time_zone" className="form-control">
                                <option defaultValue="Hawaii">(GMT-10:00) Hawaii</option>
                                <option defaultValue="Alaska">(GMT-09:00) Alaska</option>
                                <option defaultValue="Pacific Time (US &amp; Canada)">(GMT-08:00) Pacific Time (US &amp; Canada)</option>
                                <option defaultValue="Arizona">(GMT-07:00) Arizona</option>
                                <option defaultValue="Mountain Time (US &amp; Canada)">(GMT-07:00) Mountain Time (US &amp; Canada)</option>
                                <option defaultValue="Central Time (US &amp; Canada)">(GMT-06:00) Central Time (US &amp; Canada)</option>
                                <option defaultValue="Eastern Time (US &amp; Canada)">(GMT-05:00) Eastern Time (US &amp; Canada)</option>
                                <option defaultValue="Indiana (East)">(GMT-05:00) Indiana (East)</option>
                                </select>
                            </div>
                            </div>
                        </div> */}
                        <div className="form-group">
                            <label className="col-md-3 control-label">Username:</label>
                            <div className="col-md-8">
                            <input className="form-control" type="text" />
                            </div>
                        </div>
                        <div className="form-group">
                            <label className="col-md-3 control-label">Password:</label>
                            <div className="col-md-8">
                            <input className="form-control" type="password" />
                            </div>
                        </div>
                        <div className="form-group">
                            <label className="col-md-3 control-label">Confirm password:</label>
                            <div className="col-md-8">
                            <input className="form-control" type="password" />
                            </div>
                        </div>
                        <div className="form-group">
                            <label className="col-md-3 control-label"></label>
                            <div className="col-md-8 btn-block">
                            
                            <input type="button" className="custom-btn btn-banner" defaultValue="Save Changes" />
                            <span></span>
                            <input type="reset" className="custom-btn btn-banner second" defaultValue="Cancel" />
                            </div>
                        </div>
                        </form>
                    </div>
                </div>
                </div>
               
                    </TabPanel>
                    <TabPanel>
                      <div className="tab-2">
                        
                      <div className="container dashboard">
                        <div className="row">
                    <h1 className='edit'>Withdraw your Rewards Now!</h1>
                    </div>
                    <div className='withdraw'>
                    <button className="custom-btn btn-banner header">Withdraw</button>
                    </div>
                        </div>
                      </div>
                    </TabPanel>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </section>
    
      {/* <!-- content close --> */}
      <Footer />
    </>
  );
}

export default Dashboard;
